import React, { useState } from "react";
import BuscaAluno from "../../../components/SearchStudents";
import api from "../../../services/api";
import { fmtDateFull, fmtNum, todayISO } from "../../../shared/utils";

export default function Transferir({
  currentStudent,
  students,
  transfers,
  setTransfers,
  getTokensDisponiveis,
  showFlash,
}) {
  const [destId, setDestId] = useState(0);
  const [qtd, setQtd] = useState("");
  const [motivo, setMotivo] = useState("");
  const disp = Math.max(0, getTokensDisponiveis(currentStudent.id));
  const minhas = transfers
    .filter((t) => t.de === currentStudent.id || t.para === currentStudent.id)
    .sort((a, b) => b.id - a.id);
  const submit = async (e) => {
    e.preventDefault();
    if (!destId) return showFlash("Selecione o destinatario.", "er");
    const v = parseInt(qtd, 10);
    if (!v || v <= 0) return showFlash("Informe a quantidade.", "er");
    if (v > disp)
      return showFlash(`Você so tem ${fmtNum(disp)} tokens disponíveis.`, "er");
    const dest = students.find((s) => s.id === destId);

    try {
      const { data } = await api.post("/transfers", {
        de: currentStudent.id,
        para: destId,
        tokens: v,
        motivo: motivo.trim() || "Transferencia",
        data: todayISO(),
      });
      setTransfers([...transfers, data.data]);
      showFlash(`${fmtNum(v)} tokens enviados para ${dest.nome}!`);
      setQtd("");
      setMotivo("");
      setDestId(0);
    } catch (err) {
      showFlash(
        err.response?.data?.message || "Nao foi possivel enviar os tokens.",
        "er",
      );
    }
  };
  return (
    <div className="cn">
      <h1 className="pt">
        <em>Enviar</em> Tokens
      </h1>
      <div className="ps">Transfira tokens para outros alunos</div>
      <div
        style={{
          background: "rgba(255,255,255,0.1)",
          borderRadius: 11,
          padding: "12px 14px",
          marginBottom: 14,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div
            style={{
              fontSize: 10,
              color: "rgba(255,255,255,0.55)",
              fontWeight: 700,
              textTransform: "uppercase",
              letterSpacing: ".12em",
            }}
          >
            Tokens disponíveis
          </div>
          <div style={{ fontSize: 24, fontWeight: 800, color: "#4FB3A9" }}>
            {fmtNum(disp)} <small style={{ fontSize: 11 }}>Tokens</small>
          </div>
        </div>
      </div>
      <form onSubmit={submit} className="fc" style={{ marginBottom: 16 }}>
        <div
          style={{
            fontWeight: 700,
            color: "#1F4754",
            fontSize: 14,
            marginBottom: 11,
          }}
        >
          Enviar para
        </div>
        <div className="fg">
          <label>Destinatario</label>
          <BuscaAluno
            students={students.filter(
              (s) => s.ativo && s.id !== currentStudent.id,
            )}
            value={destId}
            onChange={setDestId}
          />
        </div>
        {destId > 0 && (
          <div
            style={{
              fontSize: 12,
              color: "#6B8590",
              marginBottom: 10,
              marginTop: -6,
            }}
          >
            Tokens disponíveis de{" "}
            {students.find((s) => s.id === destId)?.nome.split(" ")[0]}:{" "}
            {fmtNum(Math.max(0, getTokensDisponiveis(destId)))}
          </div>
        )}
        <div className="fg">
          <label>Quantidade de tokens</label>
          <input
            type="number"
            min="1"
            max={disp}
            className="inp"
            value={qtd}
            onChange={(e) => setQtd(e.target.value)}
            placeholder={`Max: ${fmtNum(disp)}`}
            required
          />
        </div>
        <div className="fg">
          <label>Motivo (opcional)</label>
          <input
            className="inp"
            value={motivo}
            onChange={(e) => setMotivo(e.target.value)}
            placeholder="Ex: Presente, apoio, desafio..."
          />
        </div>
        <button type="submit" className="btn bb">
          Enviar Tokens
        </button>
      </form>
      {minhas.length > 0 && (
        <>
          <div className="dv dv-dark">
            <span>Histórico de Transferencias</span>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 6 }}>
            {minhas.map((t) => {
              const enviei = t.de === currentStudent.id;
              const outro = students.find(
                (s) => s.id === (enviei ? t.para : t.de),
              );
              return (
                <div
                  key={t.id}
                  style={{
                    background: "#FFF",
                    borderRadius: 10,
                    padding: "10px 13px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                  }}
                >
                  <div>
                    <div
                      style={{
                        fontSize: 13,
                        fontWeight: 700,
                        color: "#1F4754",
                      }}
                    >
                      {enviei ? `Para ${outro?.nome}` : `De ${outro?.nome}`}
                    </div>
                    <div
                      style={{ fontSize: 11, color: "#6B8590", marginTop: 2 }}
                    >
                      {t.motivo} - {fmtDateFull(t.data)}
                    </div>
                  </div>
                  <div
                    style={{
                      fontSize: 16,
                      fontWeight: 800,
                      color: enviei ? "#D9534F" : "#4FB3A9",
                    }}
                  >
                    {enviei ? "-" : "+"}
                    {fmtNum(t.tokens)}
                    <small
                      style={{
                        fontSize: 9,
                        display: "block",
                        color: "#6B8590",
                        fontWeight: 600,
                        textTransform: "uppercase",
                        textAlign: "right",
                      }}
                    >
                      Tokens
                    </small>
                  </div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}
